import React from "react";
import { Route } from "react-router-dom";
import Page from "@ROM-pages/Orders/Edit";
import Layout from "@ROM-pages/Layouts/Authenticated";

class RouteHandler extends Route {
  render() {
    return (
      <Layout>
        <Page orderId={this.props.computedMatch.params.orderId} />
      </Layout>
    );
  }
}

export default RouteHandler;
